import { render, staticRenderFns } from "./UpdateBulkDialog.vue?vue&type=template&id=27b4d2ac"
import script from "./UpdateBulkDialog.vue?vue&type=script&lang=js"
export * from "./UpdateBulkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports